import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IceCreamComponent} from './ice-cream.component';
import {TransferComponent} from './transfer/transfer.component';
import {SharedModule} from '../../shared/shared.module';
import {UIModule} from '../ui/ui.module';
import {SelectDropDownModule} from "ngx-select-dropdown";
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UIModule,
        SelectDropDownModule
    ],
    exports: [
        TransferComponent
    ],
    declarations: [IceCreamComponent, TransferComponent, ConfirmPopupComponent],
    entryComponents: [ConfirmPopupComponent]
})
export class IceCreamModule {
}
